module.exports = __webpack_public_path__ + "static/img/right_img_tip.da44280.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/right_img_tip.png
// module id = jEDr
// module chunks = 0